import { useState } from "react";

export interface FaqItem {
  q: string;
  a: string;
}

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              aria-expanded={isOpen}
              className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-7"
            >
              <span className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-accent-100 text-xs font-bold text-accent-800">
                  Q
                </span>
                <span className="font-heading text-sm font-semibold text-foreground-900 md:text-base">
                  {item.q}
                </span>
              </span>
              <i
                className={`${
                  isOpen ? "ri-subtract-line" : "ri-add-line"
                } shrink-0 text-lg text-primary-600`}
              ></i>
            </button>
            {isOpen && (
              <div className="px-5 pb-6 pl-14 md:px-7 md:pl-16">
                <p className="text-sm leading-7 text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}